import React from 'react';
import { Tag } from 'antd';

const colors = {
  0: {
    title: 'Not Sent',
    color: 'gray',
  },
  1: {
    title: 'Sent',
    color: 'green',
  },
  2: {
    title: 'Error',
    color: 'red',
  }
};

function PrintStateInvoice({ state }) {
  if (state) {
    return (
        <Tag
          color={(colors[state] && colors[state].color) || 'lime'}
          className="mr-clear"
        >
          {(colors[state] && colors[state].title) || state}
        </Tag>
    );
  }
  return '';
}

export default PrintStateInvoice;
